import { Injectable } from "@angular/core";
import {Adapter} from "./adapter"
import { People, PeopleAdapter } from "./people";
import { Team, TeamAdapter } from "./team";

export class Skill {
    
    public peoples: People[] = [];
    public teams: Team[] =[];

    constructor(
        public id: number,
        public name: string, 
        public description: string, 
        public createdAt: Date, 
        public updatedAt: Date | null,
        public coverageCount?: number,
        public coverageStatus?: 'success' | 'warning' | 'danger' | 'secondary'
        ) {}
}

@Injectable({
    providedIn: "root",
})

export class SkillAdapter implements Adapter<Skill> {

    constructor(private peopleAdapter: PeopleAdapter,
        private teamAdapter: TeamAdapter,    
) { }

    adapt(item: any): Skill {

        const updatedAt = item.updated_at ? new Date(item.updated_at) : null;

        let skill = new Skill(item.id, item.name, item.description, new Date(item.created_at), updatedAt);
        if(item.peoples) {
            const self = this;
            skill.peoples = item.peoples.map(
                (people: People)  => this.peopleAdapter.adapt(people)
            );
        }

        if(item.teams) {
            const self = this;
            skill.teams = item.teams.map(
                (team: Team) => this.teamAdapter.adapt(team)
            );
        }

        return skill
    }

    adaptToApi(skill: Skill): any {
        return {
            name: skill.name,
            description: skill.description,
            created_at: skill.createdAt,
            updated_at: skill.updatedAt
        }
    }
}